import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { environment } from '../../../environments/environment'
import { HttpOptionsModel } from '../models/http-options.model';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private _headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient) { }
  private formatErrors(error: any) {
    console.error(error)
    return error
  }

  get(path: string, params: HttpParams = new HttpParams(), responseType?: 'json'): Observable<unknown> {
    const options: HttpOptionsModel = {
      headers: this._headers,
      responseType
    };
    return this.http.get(`${environment.apiUrl}/${path}`, { params }).pipe(catchError(this.formatErrors))
  }

  put(path: string, body = {}): Observable<unknown> {
    return this.http.put(`${environment.apiUrl}/${path}`, JSON.stringify(body)).pipe(catchError(this.formatErrors))
  }

  patch(path: string, body = {}): Observable<unknown> {
    return this.http.patch(`${environment.apiUrl}/${path}`, JSON.stringify(body)).pipe(catchError(this.formatErrors))
  }

  post(path: string, body = {}, responseType?: 'json'): Observable<unknown> {
    const options: HttpOptionsModel = {
      headers: this._headers,
      responseType
    };
    return this.http.post(`${environment.apiUrl}/${path}`, body, options)
  }

  delete(path: string): Observable<unknown> {
    return this.http.delete(`${environment.apiUrl}/${path}`).pipe(catchError(this.formatErrors))
  }
}
